
import { useEffect, useState } from 'react';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Layout from 'LayoutOfNumerologist'
import './styles.scss'
import TabMain from './components/TabMain';
import TabCore from './components/TabCore';
import Galaxy from './components/Galaxy';
import { mixPostV1 } from 'services/mixin';
import { Row, Col, Input, DatePicker, Button, Typography, Card } from "antd";
import ScrollUnlocker from 'components/FixScroll/ScrollUnlocker';
import { useTranslation } from 'react-i18next';
const { Title, Paragraph } = Typography;

const Dashboard: React.FC = () => {
    const [isShowValue, setShowValue] = useState<number>(0)
    const [lastName, setLastName] = useState("");
    const [dob, setDob] = useState<any>(null);
    const [today, setToday] = useState<string>('')
    const [showBirthday, setShowBirthday] = useState<string>('')

    const handleSubmit = async () => {
        const data = localStorage.getItem('user')

        if (data) {
            const lnData = JSON.parse(data).language

            const res = await mixPostV1('/api/v1/daily-reading', {
                birth_date: dob.format("YYYY-MM-DD"),
                current_date: today,
                locale: lnData
            })

            if (res.status) {
                localStorage.setItem('birthday', dob.format("YYYY-MM-DD"))
                localStorage.setItem('lastname', lastName)
                const formatday = dob.format("DD/MM/YYYY")
                setShowBirthday(formatday)
                setListData(res.data)
                setShowValue(1)
            }
        }
    };

    const [activeTab, setActiveTab] = useState<'main' | 'core'>('main')
    const [getBirth, setGetBirth] = useState<string>('11/02/2005')
    const [listData, setListData] = useState<any>()
    const { t } = useTranslation();

    const handleBirthChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let input = e.target.value.replace(/\D/g, '').slice(0, 8);

        let day = '';
        let month = '';
        let year = '';

        if (input.length >= 2) {
            day = input.slice(0, 2);
            let dayNum = parseInt(day);
            if (dayNum > 31) day = '31';
        } else {
            day = input.slice(0, input.length);
        }

        if (input.length >= 4) {
            month = input.slice(2, 4);
            let monthNum = parseInt(month);
            if (monthNum > 12) month = '12';
        } else if (input.length > 2) {
            month = input.slice(2);
        }

        if (input.length > 4) {
            year = input.slice(4);
        }

        // Kiểm tra ngày hợp lệ
        if (day && month && year.length >= 4) {
            const dayNum = parseInt(day);
            const monthNum = parseInt(month);
            const yearNum = parseInt(year);

            const maxDay = getMaxDayOfMonth(monthNum, yearNum);
            if (dayNum > maxDay) {
                day = String(maxDay).padStart(2, '0');
            }
        }

        // Format lại
        let formatted = '';
        if (input.length <= 2) {
            formatted = day;
        } else if (input.length <= 4) {
            formatted = `${day}/${month}`;
        } else {
            formatted = `${day}/${month}/${year}`;
        }

        setGetBirth(formatted);
    };

    const getMaxDayOfMonth = (month: number, year: number): number => {
        if (month === 2) {
            return isLeapYear(year) ? 29 : 28;
        } else if ([4, 6, 9, 11].includes(month)) {
            return 30;
        } else {
            return 31;
        }
    };

    const isLeapYear = (year: number): boolean => {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    };

    const handleClickTab = (tab: 'main' | 'core') => {
        setActiveTab(tab)
    }

    const getToday = (): any => {
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const yyyy = today.getFullYear();
        const data = `${yyyy}-${mm}-${dd}`;
        setToday(data)
    };

    function formatDate(input: string) {
        const [year, month, day] = input.split("-");
        return `${day}/${month}/${year}`;
    }

    useEffect(() => {
        getToday()
        const userString = localStorage.getItem('user')

        if (userString) {
            try {
                const parseData = JSON.parse(userString)
                const lastname = `${parseData.first_name || ''} ${parseData.last_name || ''}`

                if (parseData.birthday || localStorage.getItem('birthday')) {
                    const birthday = localStorage.getItem('birthday') ? localStorage.getItem('birthday') : parseData.birthday.split(" ")[0]
                    const formatday = formatDate(birthday)
                    setShowBirthday(formatday)
                    getData()
                } else {
                    setShowValue(2)
                }

                setLastName(lastname)
            } catch (error) {
                console.error('Lỗi parse JSON user:', error)
            }
        }
    }, [])

    const getData = async (date?: string) => {

        const userString = localStorage.getItem('user')

        if (userString) {
            const parseData = JSON.parse(userString)

            const day = localStorage.getItem('birthday') ? localStorage.getItem('birthday') : parseData?.birthday ? parseData.birthday.split(" ")[0] : ''

            const res = await mixPostV1('/api/v1/daily-reading', {
                birth_date: day,
                current_date: date ? date : today,
                locale: parseData.language
            })

            if (res.status) {
                setListData(res.data)
                setShowValue(1)
            }
        }
    }

    return (
        <Layout>
            <ScrollUnlocker />
            {isShowValue === 2 && (
                <div className='page-numerology page-numerology-none-date'>
                    <div className='space-bg__image'></div>
                    <Row gutter={24} style={{ margin: "0 auto", padding: "24px 12px" }}>
                        {/* Form bên trái */}
                        <Col xs={24} md={14}>
                            <Card style={{ borderRadius: 6 }}>
                                <Title level={4} style={{ marginBottom: 16 }}>
                                    {t('DYSthroughNum')}
                                </Title>
                                <div className='ant-sub-title' style={{ marginBottom: 8, fontWeight: 500 }}>{t('LastName')}</div>
                                <Input
                                    placeholder="Last Name"
                                    style={{ marginBottom: 16, height: 40 }}
                                    value={lastName}
                                    onChange={(e) => setLastName(e.target.value)}
                                />

                                <div className='ant-sub-title' style={{ marginBottom: 8, fontWeight: 500 }}> {t('DateOfBirth')}</div>
                                <DatePicker
                                    placeholder="Select Date"
                                    format="DD/MM/YYYY"
                                    style={{ width: "100%", height: 40, marginBottom: 20 }}
                                    value={dob}
                                    onChange={(date) => setDob(date)}
                                />

                                <div className="ctrl-btn-decode">
                                    <Button
                                        type="primary"
                                        block
                                        style={{ height: 44, maxWidth: 250, margin: "0 auto" }}
                                        onClick={handleSubmit}
                                    >
                                        {t('DecodeMPersonalYear')}
                                    </Button>
                                </div>
                            </Card>
                        </Col>

                        {/* Thông tin bên phải */}
                        <Col xs={24} md={10} className="mt-767-16px">
                            <Title level={4} style={{ marginTop: 0 }}>
                                {t('NumberologyTitle')}
                            </Title>
                            <Paragraph style={{ fontSize: 14 }}>
                                {t('NumberologyDesc')}
                            </Paragraph>
                            <Galaxy />
                        </Col>
                    </Row>
                </div>
            )}
            {isShowValue === 1 && (
                <div className='page-numerology'>

                    {/* <nav className="breadcrumb__container mb-3">
                    <div className="breadcrumb__gradient breadcrumb__gradient--left" data-gradient="left" style={{ display: 'none' }}></div>
                    <ul className="breadcrumb" data-breadcrumb-scroll-container="">
                        <li className="breadcrumb-item"><a href="/accounts-overview">Trader</a></li>
                        <li className="breadcrumb-item active">
                            Numerologist
                        </li>
                    </ul>
                    <div className="breadcrumb__gradient breadcrumb__gradient--right" data-gradient="right" style={{ display: 'none' }}></div>
                </nav> */}
                    <div className='space-bg__image'></div>

                    <div className='numerologist-container'>
                        <div className='tab-head'>
                            <div
                                className={`tab ${activeTab === 'main' ? 'active' : ''}`}
                                onClick={() => handleClickTab('main')}
                            >{t('MyDailyReadings')}</div>
                            {/* <div
                            className={`tab ${activeTab === 'core' ? 'active' : ''}`}
                            onClick={() => handleClickTab('core')}
                        >My core <br />numbers</div> */}
                            {/* <div className='tab-head-border-bottom'>
                            <img src='/images/border-bottom.png' alt='border'/>
                        </div> */}
                        </div>
                        {/* <div className="one-option-2colum">
                            <div className="left-content">Your Name</div>
                            <div className="right-content">{lastName}</div>
                        </div>
                        <div className="one-option-2colum">
                            <div className="left-content">Your Date of Birth</div>
                            <div className="right-content">{showBirthday}</div>
                        </div> */}
                        {/* <div className='img-bg-title'>
                            <img src='/images/bg-title-1.png' alt='border' />
                        </div> */}
                        <div className='tab-content-container'>
                            {/* <div id='tab-main' className='tab-content active'>
                            
                        </div>
                        <div id='tab-core' className='tab-content active'>
                            
                        </div> */}
                            {activeTab === 'main' && <TabMain listData={listData} getData={getData} />}
                            {/* {activeTab === 'core' && <TabCore />} */}
                            {/* <MySlider/> */}
                        </div>
                    </div>
                    {/* <div className="left-block-numerlogist">
                    <div className="form-getdata">
                        <div className="title-form">Tra Cứu Số Học Online</div>
                        <div className="wrap-inputs">
                            <div className="birth-input">
                                <label htmlFor="">Sinh nhật</label>
                                <input type="text" value={getBirth} onChange={handleBirthChange} />
                            </div>
                        </div>
                        <div className="wrap-btn-search">
                            <button onClick={() => getData()}>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                                </svg>
                                Tra cứu ngay
                            </button>
                        </div>
                    </div>
                </div> */}
                </div>
            )}
        </Layout>
    );
}

export default Dashboard;